import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import Sidebar from '../components/Sidebar';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

import '../assets/styles/InitiativeDetailPage.css'; // Custom styles

const InitiativeDetailPage = () => {
  const { initiativeId } = useParams();
  const [initiativeDetail, setInitiativeDetail] = useState(null);


  useEffect(() => {
    const fetchInitiativeDetail = async () => {
      try {
        const response = await fetch(`https://api.startupdriver.co/api/responses/initiative-detail/${initiativeId}`);
        const data = await response.json();
        setInitiativeDetail(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchInitiativeDetail();
  }, [initiativeId]);

  if (!initiativeDetail) {
    return <div>Loading...</div>;
  }
 
  const barChartData = {
    labels: ['12 Months', '24 Months', '36 Months'],
    datasets: [
      {
        label: 'Exit Probability (%)',
        data: [
          initiativeDetail.exitProbabilities?.months12,
          initiativeDetail.exitProbabilities?.months36,
          initiativeDetail.exitProbabilities?.months48,
        ],
        backgroundColor: ['#abe147'], 
      },
    ],
  };
  

  const barChartOptions = {
    indexAxis: 'x',
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };

  return (
    
    <div className="initiative-detail-page">
      <Sidebar />
      <h1 className="initiative-title">{initiativeDetail.initiativeName}</h1>
      
      {/* Cards for each metric */}
      <div className="metrics-cards">
        <div className="first-card">
          <h3>Sector</h3>
          <p >{initiativeDetail.sector}</p>
          <h3>Funding</h3>
          <p>{initiativeDetail.funding}</p>
          <h3>Current Month's MRR</h3>
          <p>${initiativeDetail.currentMrr}</p>
          <h3>Previous Month's MRR</h3>
          <p>${initiativeDetail.previousMrr}</p>
        </div>
       
        <div className="card">
          <h3>MRR Growth Rate</h3>
          <p className="metric-value">{initiativeDetail.growthRate}%</p>
          <p className= "insight">📈 {initiativeDetail.mrrGrowthInsight}</p>
        </div>
     
        <div className="card">
          <h3>LTV/CAC Ratio</h3>
          <p className="metric-value">{initiativeDetail.ltvCacRatio}</p>
          <p className= "insight">📈 {initiativeDetail.customerPotentialInsight}</p>
        </div>
        <div className="card">
          <h3>Exit Multiple Insight</h3>
          <p className= "insight">📈 {initiativeDetail.exitMultipleInsight}</p>
        </div>
        <div className="card">
          <h3>Exit Value Range</h3>
          <p className="metric-value">{initiativeDetail.exitValueRange}</p>
        </div>
      </div>

      {/* Exit Probabilities Chart */}
      <div className="exit-probabilities-section">
        <h3 className="section-title">Exit Probabilities</h3>
        <Bar data={barChartData} options={barChartOptions} className="exit-probabilities-chart" />
      </div>
    </div>
  );
};

export default InitiativeDetailPage;